<h2>{{ 'global-forms.dtm.title' | translate }}</h2>

<form [formGroup]="addDTMForm" (ngSubmit)="onAddLandscape()">

  <!-- TODO: Replace this part to permissions field component-->

  <div class="form-row">
    <mat-form-field>
      <input
        formControlName="company"
        type="text"
        [placeholder]="'components.dtmTab.customElevations.company' | translate"
        required
        matInput
        [matAutocomplete]="auto"
        autocomplete="off"
        [matAutocompleteDisabled]="isCompanyAdmin"
      />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onCompanyChange($event)"
                        [displayWith]="displayCompanyProperty">
        <mat-option *ngFor="let company of filteredCompaniesData$ | async" [value]="company">
          {{ company.Name }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="addDTMForm.get('company').errors && addDTMForm.get('company').errors.required">
        {{ 'validation.required' | translate: { name: ('components.dtmTab.customElevations.company' | translate) } }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field>
      <input matInput placeholder="{{ 'components.dtmTab.customElevations.name' | translate }}" required
             formControlName="name" />
      <mat-error *ngIf="isRequiredError('name')">
        {{ 'validation.required' | translate: { name: ('components.dtmTab.customElevations.name' | translate) } }}
      </mat-error>
      <mat-error *ngIf="addDTMForm.get('name').errors && addDTMForm.get('name').errors.notUnique">
        {{ 'components.dtmTab.customElevations.customElevationUniqueName' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field>
      <input
        matInput
        formControlName="slug"
        required
        [placeholder]="'components.dtmTab.customElevations.slug' | translate"
        [maxLength]="identifierMaxLength"
      />
      <mat-error *ngIf="addDTMForm.get('slug').errors && addDTMForm.get('slug').errors.pattern">
        {{ 'validation.is_not_valid' | translate: { name: ('components.dtmTab.customElevations.slug' | translate) } }}
      </mat-error>
      <mat-error *ngIf="addDTMForm.get('slug').errors && addDTMForm.get('slug').errors.required">
        {{ 'validation.required' | translate: { name: ('components.dtmTab.customElevations.slug' | translate) } }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field>
      <mat-icon class="help-tooltip"
                *ngIf="isShowScopeTooltip"
                [matTooltip]="getScopeTooltipText()">
        help_outline
      </mat-icon>
      <mat-select
        formControlName="scope"
        required
        [disabled]='isTeamAdmin'
        placeholder="{{ 'permissions.visibility' | translate }}"
      >
        <mat-option [value]="scopes.CompanyScope">
          {{ 'permissions.scope.company' | translate }}
        </mat-option>
        <mat-option [value]="scopes.TeamPublicScope">
          {{ 'permissions.scope.teamPublic' | translate }}
        </mat-option>
        <mat-option [value]="scopes.TeamPrivateScope"
                    [disabled]="isPrivateVisibilityDisabled"
        >
            <span [matTooltip]="privateVisibilityDisabledTooltipText | translate">
              {{ 'permissions.scope.teamPrivate' | translate }}
            </span>
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
            addDTMForm.get('scope').errors &&
            addDTMForm.get('scope').errors.required &&
            (addDTMForm.get('scope').dirty || addDTMForm.get('scope').touched)
          "
      >{{ 'validation.required' | translate: { name: ('permissions.Scope' | translate) } }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="warning-about-set-public" *ngIf="isShowWarningAboutSetPublic">
    <mat-icon class="icon">error_outline</mat-icon>
    <p class="text">{{'permissions.warningAboutSetPublic' | translate}}</p>
  </div>

  <div class="form-row" *ngIf="isShowTeamField">
    <mat-form-field>
      <input
        formControlName="ownerTeamId"
        type="text"
        [placeholder]="'components.dtmTab.customElevations.team' | translate"
        matInput
        required
        [matAutocomplete]="auto"
        autocomplete="off"
        [matAutocompleteDisabled]="isTeamAdmin"
      />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onTeamChange($event)"
                        [displayWith]="displayTeamProperty">
        <mat-option *ngFor="let company of filteredTeamsData$ | async" [value]="company">
          {{ company.Name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field>
      <mat-select
        formControlName="elevationProviderType"
        required
        disabled
        placeholder="{{ 'components.dtmTab.customElevations.elevationType' | translate }}"
      >
        <mat-option *ngFor="let landscape of landscapes" [value]="landscape.value">
          {{ landscape.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="isRequiredError('elevationProviderType')"
      >{{ 'validation.required' | translate: { name: ('components.dtmTab.customElevations.ElevationTypeErrorText' | translate) } }}
      </mat-error>
    </mat-form-field>
  </div>

  <mee-arcgis-custom-dtm-form (arcGisDataChanged)="arcGisDataChanged($event)"></mee-arcgis-custom-dtm-form>

  <div class="buttons">
    <button mat-ripple class="cancel-button" [mat-dialog-close]="true"
            type="button">{{ 'global-forms.cancel' | translate }}</button>
    <button mat-ripple class="apply-button" type="submit"
            [ngClass]="{'disabled' : isArcGisFormInvalid()}"
            [disabled]="isArcGisFormInvalid()">
      {{ 'global-forms.add' | translate }}
    </button>
  </div>
</form>
